import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * 用户类型选择弹窗状态管理
 * 用于持久化存储用户是否已经打开过身份选择弹窗
 */
export const useUserTypePopupStore = defineStore(
  'userTypePopup',
  () => {
    // 是否已经展示过弹窗
    const hasShownPopup = ref<boolean>(true)

    /**
     * 设置弹窗已展示状态
     */
    function setHasShownPopup(value: boolean) {
      hasShownPopup.value = value
    }

    /**
     * 标记弹窗已展示
     */
    function markPopupAsShown() {
      hasShownPopup.value = true
    }

    /**
     * 重置弹窗状态（用于测试或特殊场景）
     */
    function resetPopupState() {
      hasShownPopup.value = false
    }

    /**
     * 检查是否需要展示弹窗
     * @returns 如果未展示过弹窗返回 true
     */
    function shouldShowPopup(): boolean {
      return !hasShownPopup.value
    }

    return {
      hasShownPopup,
      setHasShownPopup,
      markPopupAsShown,
      resetPopupState,
      shouldShowPopup,
    }
  },
  {
    persist: true,
  },
)
